import type { IconProps } from './IconsTypes'

export const PlayIcon = ({
  width = 24,
  height = 24,
  viewBox = '0 0 24 24',
  color = '#323232',
  ariaHidden,
  focusable,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      aria-hidden={ariaHidden}
      focusable={focusable}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={width} height={height} fill="none" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5.49686C3 3.17662 5.52116 1.73465 7.52106 2.91106L18.5764 9.41423C20.5484 10.5742 20.5484 13.4259 18.5764 14.5858L7.52106 21.089C5.52116 22.2654 3 20.8234 3 18.5032V5.49686Z"
        fill={color}
      />
    </svg>
  )
}
